export default {"src":"/_next/static/media/AA.379fd3e9.svg","height":18,"width":18};